import { Contract, ContractTenant } from '../../../../common/validations'
import { isAdultTenant } from './isAdultTenant'

export const canContinueWithRemainingTenant = (
  contract: Contract,
  tenants: ContractTenant[]
) =>
  contract.tenant.isContractParty &&
  tenants.some(
    (tenant) => tenant.id !== contract.tenant.id && isAdultTenant(tenant)
  )
